import IconBubble, { BubbleTone } from "components/IconBubble";
import { ReactNode } from "react";
import "./index.css";

/**
 * A person page section's title with its tinted icon, as the Details card
 * labels its rows. A long title ends in "…".
 */
export default function SectionTitle({
  icon,
  tone,
  children,
}: {
  icon: ReactNode;
  tone: BubbleTone;
  children: ReactNode;
}) {
  return (
    <h2 className="section-title">
      <IconBubble tone={tone}>{icon}</IconBubble>
      <span className="min-w-0 truncate">{children}</span>
    </h2>
  );
}
